import { FC, ImgHTMLAttributes } from "react";
import { Image } from "../Image/Image";
import {
  IAvatarSize,
  DefaultProfileSrcSet,
  AvatarWidthMapping,
  getSizeBadge,
} from "../../../constants/user";
import { useStyles } from "./Avatar.style";
import Badge from "../Badge/Badge";
import { ILevel } from "../../../types/user";
import clsx from "classnames";
import { ProgressIndicator } from "@onmo/ui";

interface IAvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  userRank?: ILevel;
  url?: string;
  size?: IAvatarSize;
  alt?: string;
  status?: "online" | "offline" | "away";
  hideProgress?: boolean;
}

const Avatar: FC<IAvatarProps> = (props) => {
  const {
    id,
    url,
    userRank,
    size = "s",
    status,
    alt,
    onLoad,
    hideProgress,
    ...otherProps
  } = props;
  const classes = useStyles();

  const avatarWidth = AvatarWidthMapping[size];
  const avatarHeight = AvatarWidthMapping[size];

  const getSizeProgress = (size: IAvatarSize) => {
    switch (size) {
      case "s":
        return "small";
      case "m":
        return "medium";
      case "l":
        return "large";
    }
  };

  return (
    <div className={classes.root} {...otherProps}>
      <Image
        id={id}
        srcSet={url || DefaultProfileSrcSet}
        className={classes.root}
        url={url || DefaultProfileSrcSet}
        width={avatarWidth}
        radius={"50%"}
        height={avatarHeight}
        alt={alt}
        onLoad={onLoad}
      />
      {userRank?.id && getSizeBadge(size) && (
        <Badge
          size={getSizeBadge(size)}
          type={userRank.id}
          className={classes.rank}
          id={"badge"}
          data-testid="rank-badge"
        />
      )}
      {status && <div className={clsx(classes.status, status)} />}
      {!hideProgress && userRank && (
        <ProgressIndicator
          color={userRank.color || ""}
          value={{
            initial: userRank.levelPercent || 0,
            total: 100,
            target: userRank.levelPercent || 0,
          }}
          type="circle"
          size={getSizeProgress(size)}
          className={classes.progress}
          strokeWidth={2}
        />
      )}
    </div>
  );
};

export default Avatar;
